/**
 * In-memory session store for audio recording.
 * All methods are async to match the IndexedDB interface.
 */
import sessionId from "../session_id.js";

class MemorySession {
  constructor({ id, store }) {
    this.id = id;
    this.startedAt = new Date();
    this.status = "recording";
    this._chunks = [];
    this._store = store;
  }

  async addChunk(index, blob) {
    this._chunks.push({ index, blob });
  }

  async chunks() {
    return this._chunks
      .sort((a, b) => a.index - b.index)
      .map(c => c.blob);
  }

  async duration() {
    const chunks = await this.chunks();
    return MemorySession.formatDuration(chunks.length);
  }

  async update(attrs) {
    Object.assign(this, attrs);
  }

  async delete() {
    this._store.sessions.delete(this.id);
  }

  static formatDuration(chunkCount) {
    const totalSeconds = chunkCount * 10;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
  }
}

export default class MemorySessionStore {
  constructor() {
    this.sessions = new Map();
  }

  async create() {
    const id = sessionId();
    const session = new MemorySession({ id, store: this });
    this.sessions.set(id, session);
    return session;
  }

  async all() {
    return [];
  }
}
